export default __webpack_public_path__ + "media/Tools.38a90d3633c01c281d3abf9ea2509433.svg";